module.exports = "/_next/static/images/70118377b1ad1db19c2b2a9483f6657b-cartao-proximo-ao-olho-md@3x.jpg";